import { ICheckedFilter, IRadioFilter, RadioFilterTypes } from 'types/location.js';
import { LegendsFilterToggle } from './legends-filter-toggle.js';
import { LegendsFilter } from './legends-filter.js';

export interface LegendsFilterProps {
  checkboxFilters?: Array<ICheckedFilter>;
  checkboxFilterOnClick: (filter: ICheckedFilter) => void;
  radioFilterOnClick: (markerType: RadioFilterTypes) => void;
  radioActiveFilter?: string;
  radioFilters?: Array<IRadioFilter>;
  checkBoxFilterLabel?: string;
  radioFilterLabel?: string;
}

const DEFAULT_CHECKBOX_FILTER_LABEL = 'Filters';
const DEFAULT_RADIO_FILTER_LABEL = 'Select a Marker Type';

export const LegendsFilters = ({
  radioFilters,
  radioActiveFilter,
  radioFilterLabel,
  checkboxFilters,
  checkBoxFilterLabel,
  checkboxFilterOnClick,
  radioFilterOnClick,
}: LegendsFilterProps) => {
  if (checkboxFilters) {
    const _radioFilters = radioFilters || [];
    const showMarkerFilters = _radioFilters.length > 0;
    const toggleAllFilter = checkboxFilters.length > 1;

    return (
      <>
        {showMarkerFilters && (
          <p className="h2 u-pB-xs u-bB-1 u-mB-sm">{checkBoxFilterLabel || DEFAULT_CHECKBOX_FILTER_LABEL}</p>
        )}

        {toggleAllFilter && (
          <LegendsFilterToggle
            filters={checkboxFilters}
            key={0}
            idx={0}
            className={'u-mB-sm'}
            checkboxFilterOnClick={checkboxFilterOnClick}
          />
        )}

        {checkboxFilters.map((filter, idx) => {
          const index = toggleAllFilter ? idx + 1 : idx;
          const className = checkboxFilters.length !== index + 1 ? 'u-mB-sm' : '';
          return (
            <LegendsFilter
              filter={filter}
              key={index}
              idx={index}
              className={className}
              checkboxFilterOnClick={checkboxFilterOnClick}
            />
          );
        })}

        {showMarkerFilters && (
          <>
            <p className="h2 u-pB-xs u-bB-1 u-mT-responsive">{radioFilterLabel || DEFAULT_RADIO_FILTER_LABEL}</p>
            {/* @TODO Marker Type should come from the API */}
            {_radioFilters.map(({ key, label }, idx) => {
              const radioLabelId = `radio-${key}`;
              const checked = radioActiveFilter === key;

              return (
                <label htmlFor={radioLabelId} className="Radio" key={idx}>
                  <input
                    id={radioLabelId}
                    className="Radio-input"
                    type="radio"
                    checked={checked}
                    name={radioLabelId}
                    onChange={() => radioFilterOnClick(key)}
                  />
                  <small className="Radio-label Radio-label--rightAlign">{label}</small>
                </label>
              );
            })}
          </>
        )}
      </>
    );
  }
  return null;
};
